import {Component, Input} from '@angular/core';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';

export interface IStaffAccessStoreChange {
  afterRole: string;
  beforeRole: string;
  storeName: string;
}

export interface IStaffAccessUserChange {
  storeChanges: IStaffAccessStoreChange[];
  userEmail: string;
  userName: string;
}

/** @deprecated Use IStaffAccessUserChange grouped via buildPendingUserChanges */
export interface IStaffAccessChangeRow {
  afterRole: string;
  beforeRole: string;
  storeName: string;
  userEmail: string;
  userName: string;
}

export interface IStaffAccessSaveChangesModalResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-staff-access-save-changes-modal',
  templateUrl: './staff-access-save-changes-modal.component.html',
  styleUrls: ['./staff-access-save-changes-modal.component.scss'],
  standalone: false,
})
export class StaffAccessSaveChangesModalComponent {
  @Input() userChanges: IStaffAccessUserChange[] = [];

  protected readonly icons = IconsEnum;
  protected readonly iconColourEnum = IconColourEnum;

  constructor(private readonly modalController: ModalControllerService) {}

  protected async onCancel(): Promise<void> {
    await this.modalController.dismiss({confirmed: false} satisfies IStaffAccessSaveChangesModalResult);
  }

  protected async onConfirm(): Promise<void> {
    await this.modalController.dismiss({confirmed: true} satisfies IStaffAccessSaveChangesModalResult);
  }

  protected trackUser(_index: number, user: IStaffAccessUserChange): string {
    return user.userEmail;
  }

  protected trackStoreChange(_index: number, change: IStaffAccessStoreChange): string {
    return `${change.storeName}:${change.beforeRole}:${change.afterRole}`;
  }
}
